"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LincdCometChat = void 0;
const uikit_shared_1 = require("@cometchat/uikit-shared");
const chat_uikit_react_1 = require("@cometchat/chat-uikit-react");
//import {CometChat} from '@cometchat-pro/chat';
const chat_sdk_javascript_1 = require("@cometchat/chat-sdk-javascript");
const User_1 = require("./User");
const UserAccount_1 = require("lincd-sioc/lib/shapes/UserAccount");
// let loginPromises = new Map<string, Promise<CometChat.User | void>>();
class LincdCometChat {
    constructor() {
        this.loggedInUser = null;
        this.createUserPromises = new Map();
        this.nameListenerAdded = false;
    }
    logout() {
        return this.init().then(() => {
            chat_uikit_react_1.CometChatUIKit.logout();
            this.loginPromise = null;
        });
    }
    init() {
        if (!this.initPromise) {
            const appID = process.env.COMET_CHAT_APP_ID;
            const region = process.env.COMET_CHAT_REGION;
            const authKey = process.env.COMET_CHAT_AUTH_KEY;
            const UIKitSettings = new uikit_shared_1.UIKitSettingsBuilder()
                .setAppId(appID)
                .setRegion(region)
                .setAuthKey(authKey)
                .subscribePresenceForFriends()
                .build();
            //Capacitor.getPlatform() === "web" &&
            if (typeof window !== 'undefined') {
                this.initPromise = chat_uikit_react_1.CometChatUIKit.init(UIKitSettings)
                    .then(() => {
                    console.log('Comet chat initialised');
                })
                    .catch(console.log);
            }
        }
        return this.initPromise;
    }
    toFullyLoadedCometChatUser(person, userData) {
        //TODO: this needs to be improved an will not work for different setups with Person classes don't support this temporary fix
        if (person instanceof Promise) {
            return person
                .then((resolvedPerson) => {
                return this.toCometChatUser(resolvedPerson, userData);
            })
                .catch((error) => {
                throw new Error('Error while resolving the Promise: ' + error.message);
            });
        }
        else {
            // Create a Promise that immediately resolves with the person
            return Promise.resolve(this.toCometChatUser(person, userData));
        }
    }
    toCometChatUser(person, userData) {
        return new chat_sdk_javascript_1.CometChat.User((0, User_1.toCometChatUserData)(UserAccount_1.UserAccount.getAccountOf(person), userData));
    }
    ensureLoggedIn(person, getUserData) {
        return __awaiter(this, void 0, void 0, function* () {
            // User does not exist, even though it should have been created during signup... test data?
            //if the users' name is not yet set, we listen to any changes to the person and try to login again
            if (!(person.givenName || person.name)) {
                if (!this.nameListenerAdded) {
                    this.nameListenerAdded = true;
                    person.onChangeAny(() => {
                        this.ensureLoggedIn(person, getUserData);
                    });
                    console.log('The user does not have a name yet, cannot create a cometchat user without a name. Will login after name is set', person);
                }
                return Promise.resolve();
            }
            if (!this.loginPromise) {
                this.loginPromise = this.init().then(() => __awaiter(this, void 0, void 0, function* () {
                    this.loggedInUser = yield chat_sdk_javascript_1.CometChat.getLoggedinUser();
                    // const loggedInUser = await CometChatUIKit.getLoggedinUser();
                    if (this.loggedInUser) {
                        if (this.loggedInUser.getUid() !== (0, User_1.getUID)(person)) {
                            console.log('Logged in user is not the same as the user we want to log in as, logging out first');
                            yield this.logout();
                        }
                        else {
                            //all good, already logged in with the right user
                            return this.loggedInUser;
                        }
                    }
                    //if not logged in yet, log in now
                    return this.login(person, getUserData).then(() => __awaiter(this, void 0, void 0, function* () {
                        //temporary: update the user after logging in (avatar, name, etc)
                        //TODO: make sure avatar is updated
                        // let updatedUser = await this.toFullyLoadedCometChatUser(person);
                        // await CometChat.updateUser(
                        //   updatedUser,
                        //   process.env.COMET_CHAT_AUTH_KEY,
                        // ).catch((err) => {
                        //   console.warn("Couldn't update cometchat user", err);
                        //   if (err.code === 'ERR_UID_NOT_FOUND') {
                        //     // return this.createUser(person, false).then(() => {
                        //     return this.ensureLoggedIn(person);
                        //     // });
                        //   }
                        // });
                        return this.loggedInUser;
                    }));
                }));
            }
            return this.loginPromise;
        });
    }
    getLoggedInUser() {
        return this.loggedInUser;
    }
    login(person, getUserData) {
        return __awaiter(this, void 0, void 0, function* () {
            let uid = (0, User_1.getUID)(person);
            try {
                this.loggedInUser = yield chat_sdk_javascript_1.CometChat.login(uid, process.env.COMET_CHAT_AUTH_KEY);
                console.log('Login successful, loggedInUser:', this.loggedInUser);
                return this.loggedInUser;
            }
            catch (error) {
                // if (error instanceof CometChat.CometChatException && error.message) {
                //   //setErrorMessage(error.message);
                // }
                if (error.code === 'ERR_UID_NOT_FOUND') {
                    console.log('CometChat user does not exist, creating...');
                    return this.createUser(person, true, getUserData)
                        .then((cometChatUser) => {
                        //make sure the CometChat user came back (and was successfully created), if not we would go into loops
                        if (cometChatUser) {
                            return this.login(person);
                        }
                    })
                        .catch((error) => {
                        console.log('error', error);
                    });
                }
                else {
                    console.log('login failed', error);
                }
                // console.log(error);
            }
            //TODO: use loginWithAuthToken() here, which is uniquely generated on the backend for each user/device combo
            // return CometChatUIKit.login(uid)
            //   .then((user) => {
            //     console.log('Login Successful:', {user});
            //     return user;
            //   })
            //   .catch((err) => {
            //     if (err.code === 'ERR_UID_NOT_FOUND') {
            //       // User does not exist, even though it should have been created during signup... test data?
            //       console.log('CometChat user does not exist, creating...');
            //       return createUser(person)
            //         .then(() => {
            //           return login(person);
            //         })
            //         .catch((error) => {
            //           console.log('error', error);
            //         });
            //     }
            //     console.log(err);
            //   });
        });
    }
    ensureUserExists(person) {
        return __awaiter(this, void 0, void 0, function* () {
            this.loggedInUser = yield this.init().then(() => chat_sdk_javascript_1.CometChat.getLoggedinUser());
            console.log('logged in user', this.loggedInUser);
            if (!this.loggedInUser) {
                const cometChatUser = yield this.createUser(person, false);
                if (cometChatUser) {
                    return this.ensureLoggedIn(person);
                }
            }
            return this.loggedInUser;
        });
    }
    createUser(person_1) {
        return __awaiter(this, arguments, void 0, function* (person, warnIfAlreadyExists = true, userData) {
            if (!this.createUserPromises.has(person)) {
                this.createUserPromises.set(person, this._createUser(person, warnIfAlreadyExists, userData));
            }
            return this.createUserPromises.get(person);
        });
    }
    _createUser(person_1) {
        return __awaiter(this, arguments, void 0, function* (person, warnIfAlreadyExists = true, userData) {
            // Server.call(
            //   packageName,
            //   'createUserAccount',
            //   person,
            //   UserAccount.getAccountOf(person as any),
            // );
            let newUser = yield this.toFullyLoadedCometChatUser(person, userData);
            //TODO: should we allow frontend user creation? Or should we only allow it on the backend?
            try {
                // user = await CometChatUIKit.createUser(user);
                const createdUser = yield chat_sdk_javascript_1.CometChat.createUser(newUser, process.env.COMET_CHAT_AUTH_KEY);
                console.log('User created successfully:', createdUser);
                return createdUser;
            }
            catch (error) {
                if (error.code === 'ERR_UID_ALREADY_EXISTS') {
                    if (warnIfAlreadyExists) {
                        console.log('User already exists:', newUser.getUid());
                    }
                    return newUser;
                }
                console.log('error creating new user', error);
            }
        });
    }
    /**
     * https://cometchat-docs.developerhub.io/docs/javascript-chat-sdk/groups-retrieve-groups#retrieve-particular-group-details
     *
     * @param groupID
     * @returns
     */
    getGroup(groupID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield chat_sdk_javascript_1.CometChat.getGroup(groupID);
        });
    }
    /**
     * https://cometchat-docs.developerhub.io/docs/javascript-chat-sdk/groups-join-group#join-a-group
     *
     * @param groupID
     * @param type
     * @param password
     * @returns
     */
    joinGroup(groupID, type, password) {
        return __awaiter(this, void 0, void 0, function* () {
            let groupType;
            if (type === 'password') {
                groupType = chat_sdk_javascript_1.CometChat.GroupType.Password;
            }
            else if (type === 'private') {
                groupType = chat_sdk_javascript_1.CometChat.GroupType.Private;
            }
            else if (type === 'public') {
                groupType = chat_sdk_javascript_1.CometChat.GroupType.Public;
            }
            return yield chat_sdk_javascript_1.CometChat.joinGroup(groupID, groupType, password);
        });
    }
    /**
     * get group members
     * https://cometchat-docs.developerhub.io/docs/javascript-chat-sdk/groups-retrieve-group-members
     *
     * @param guid
     * @param limit
     * @param searchKeyword
     * @param scopes
     * @returns
     */
    getGroupMembers(guid_1) {
        return __awaiter(this, arguments, void 0, function* (guid, limit = 100, searchKeyword, scopes) {
            try {
                let groupMembersRequestBuilder = new chat_sdk_javascript_1.CometChat.GroupMembersRequestBuilder(guid).setLimit(limit);
                if (searchKeyword) {
                    groupMembersRequestBuilder =
                        groupMembersRequestBuilder.setSearchKeyword(searchKeyword);
                }
                if (scopes) {
                    groupMembersRequestBuilder =
                        groupMembersRequestBuilder.setScopes(scopes);
                }
                const groupMembersRequest = groupMembersRequestBuilder.build();
                return yield groupMembersRequest.fetchNext();
            }
            catch (error) {
                if (error.code === 'ERR_GUID_NOT_FOUND') {
                    console.warn(`Group ${guid} not found`);
                }
                else {
                    console.warn(`Group ${guid} fetching members failed with error:`, error);
                }
            }
        });
    }
    /**
     * https://cometchat-docs.developerhub.io/docs/javascript-chat-sdk/messaging-delete-message#delete-a-message
     * in their docs example messageID is a number, but in the types it's a string
     *
     * @param messageID
     * @returns
     */
    deleteMessage(messageID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield chat_sdk_javascript_1.CometChat.deleteMessage(messageID);
        });
    }
    /**
     * https://cometchat-docs.developerhub.io/docs/extensions/report-message
     *
     * @param slug
     * @param method
     * @param endpoint
     * @param data
     * @returns
     */
    callExtension(slug, method, endpoint, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield chat_sdk_javascript_1.CometChat.callExtension(slug, method, endpoint, data);
        });
    }
    /**
     * https://cometchat-docs.developerhub.io/docs/v4/javascript-chat-sdk/messaging-retrieve-conversations
     *
     * @param limit
     * @param conversationType
     * @param withTags
     * @param userTags
     * @param groupTags
     * @param tags
     * @returns
     */
    conversationsRequestBuilder(limit, conversationType, withTags, userTags, groupTags, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let conversationRequestBuilder = new chat_sdk_javascript_1.CometChat.ConversationsRequestBuilder().setLimit(limit);
                if (conversationType) {
                    conversationRequestBuilder.setConversationType(conversationType);
                }
                if (withTags) {
                    conversationRequestBuilder.withTags(withTags);
                }
                if (userTags) {
                    conversationRequestBuilder.setUserTags(userTags);
                }
                if (groupTags) {
                    conversationRequestBuilder.setGroupTags(groupTags);
                }
                if (tags) {
                    conversationRequestBuilder.setTags(tags);
                }
                let conversationRequest = conversationRequestBuilder.build();
                let conversationList = yield conversationRequest.fetchNext();
                return conversationList;
            }
            catch (error) {
                console.error('Conversations list fetching failed with error:', error);
                throw error;
            }
        });
    }
    /**
     * https://docs.cometchat.io/javascript/v3.0/api-reference/classes/cometchat.html#getmessagedetails
     *
     * @param messageId
     * @returns
     */
    getMessageDetails(messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield chat_sdk_javascript_1.CometChat.getMessageDetails(messageId);
        });
    }
    /**
     * https://docs.cometchat.io/javascript/v3.0/api-reference/classes/cometchat.html#blockusers
     *
     * @param blockedUids
     * @returns
     */
    blockUsers(blockedUids) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield chat_sdk_javascript_1.CometChat.blockUsers(blockedUids);
        });
    }
    /**
     * https://cometchat-docs.developerhub.io/docs/web-shared/message-template#list-all-available-templates
     *
     * @returns
     */
    getAllMessageTemplates() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            return (_a = chat_uikit_react_1.CometChatUIKit.getDataSource()) === null || _a === void 0 ? void 0 : _a.getAllMessageTemplates();
        });
    }
}
exports.LincdCometChat = LincdCometChat;
//# sourceMappingURL=CometChat.js.map